import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Text} from '@optimaxdev/design-system';
import {Icon, FullArrowRight} from '@optimaxdev/icons';

import {Link} from 'react-router-dom';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import {TYP_BOTTOM_SECTION} from 'constants/analytics/events/typ';

import contactsIcon from '../img/contacts2xComp.png';
import eyeglassesIcon from '../img/eyeglasses2xComp.png';
import sunglassesIcon from '../img/sunglasses2xComp.png';

export enum ShopCategories {
    eyeglasses = 'eyeglasses',
    sunglasses = 'sunglasses',
    contacts = 'contacts',
}

type PropsType = {
    category: ShopCategories;
};

import s from './shopCategory.scss';

export const options = {
    [ShopCategories.contacts]: {
        image: contactsIcon,
        link: '/contact-lenses',
        title: 'Shop Contacts',
    },
    [ShopCategories.eyeglasses]: {
        image: eyeglassesIcon,
        link: '/eyeglasses-collection',
        title: 'Shop Eyeglasses',
    },
    [ShopCategories.sunglasses]: {
        image: sunglassesIcon,
        link: '/sunglasses',
        title: 'Shop Sunglasses',
    },
};

/**
 * Shop category
 * @param {PropsType} props - Component props
 * @return {React.ReactElement} component
 */
export const ShopCategory: FC<PropsType> = ({category}) => {
    const sendAnalytics = () => {
        sendDesktopAnalyticsEvent(
            TYP_BOTTOM_SECTION,
            {
                action: 'Keep Shopping',
                label: `CTA - ${options[category].title} - Clicked`,
            },
            true,
        );
    };

    return (
        <Link className={s.container} onClick={sendAnalytics} to={options[category].link}>
            <span className={s.leftBlock}>
                <CloudinaryImage
                    alt={category}
                    className={s.categoryIcon}
                    height="64px"
                    src={options[category].image}
                    width="64px"
                />
                <Text
                    as="span"
                    className={s.title}
                    color={Colors.blueCharcoal}
                    letterSpacing="normal"
                    lineHeight="20px"
                    size="18px"
                    bold
                >
                    {options[category].title}
                </Text>
            </span>
            <Icon className={s.icon} icon={FullArrowRight} />
        </Link>
    );
};
